<template>
  <div class="root_page">
    <div class="table_wrapper">
      <div class="ctrl-wrapper">
        <div class="search_wrapper">
          <div class="common_search_wrapper">
            <Button
              type="primary"
              icon="md-add"
              class="search_tn"
              data-level="common"
              @click="addListModal = true"
            >新建</Button>
          </div>
        </div>
      </div>
      <Table
        class="main_table"
        size="large"
        stripe
        border
        :columns="tableHeader"
        :data="tableData"
        @on-selection-change="selectedChange"
      >
        <template slot-scope="{row}" slot="status">
          <span v-if="row.status < 3">未铺码</span>
          <span v-if="row.status == 3">铺码中</span>
          <span v-if="row.status == 4">铺码完成</span>
          <span v-if="row.status == 9">铺码失败，请联系客服</span>
        </template>
        <template slot-scope="{ row, index}" slot="action">
          <a class="jump_color" @click="toEditor(row)">编辑</a>
          <a class="jump_color" @click="toAddAnswer(row)">录入答案</a>
          <a class="jump_color" @click="paperSsheetsImages(row.sheetId)">上传图片</a>
          <a class="jump_color" @click="startChapterLayingCode(row.sheetId)">铺码</a>
          <a
            :href="downLoadPdf + row.dotFile"
            :download="downLoadPdf + row.dotFile"
            target="_blank"
            v-if="row.dotFile"
            class="jump_color"
          >下载PDF</a>
          <a class="jump_color" @click="toQuestionBank(row)">题库</a>
          <a class="jump_color" @click="deleteChapter(row)">删除</a>
        </template>
      </Table>
    </div>
    <paging :totalNum="totalNum" :pageSize="pageSize" @pageCallback="getAnswerChapterList"></paging>
    <Modal
      class="top_search_modal"
      v-model="addListModal"
      title="新建章节"
      @on-visible-change="addEditorChange"
    >
      <div class="top_search_wrapper">
        <Input
          class="search-ipt search_item"
          type="text"
          v-model="addEditorData.name"
          placeholder="请输入章节名称"
          clearable
        />
        <Input
          class="search-ipt search_item"
          type="number"
          v-model="addEditorData.seqno"
          placeholder="请输入章节序号"
          clearable
        />
        <div class="search-ipt search_item order_mode">
          <span class="search_item_label">小题排序</span>
          <RadioGroup v-model="addEditorData.mode" @on-change="changeSortOrder">
            <Radio class="radio_item" size="large" label="每道大题重新排列"></Radio>
            <Radio class="radio_item" size="large" label="连续排序"></Radio>
          </RadioGroup>
        </div>
      </div>
      <div class="ctrl-footer" slot="footer">
        <Button class="closed_btn" @click="addListModal = false">取消</Button>
        <Button class="add_record_btn" type="info" @click="confirmAddEditor">下一步</Button>
      </div>
    </Modal>
    <Modal class="delete_modal" title="删除" v-model="deleteStatus">
      <p class="delete_tips_info">确定要将"{{deletedTitle}}"删除吗？</p>
      <div class="ctrl-footer" slot="footer">
        <Button class="closed_btn" @click="deleteStatus = false">取消</Button>
        <Button class="add_record_btn" type="info" @click="confirmDeleteBtn">确定</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import paging from "../templates/Paging.vue";
import {
  _getAnswerChapterList,
  _getConfirmAddChapter,
  _deleteChapter,
  _startChapterLayingCode,
  _paperSsheetsImages
} from "../api/api";
import { YearMonthDate, alertTips } from "../common/common";
import globalData from "../common/Global";
let timer = null;
export default {
  components: { paging },
  data() {
    return {
      pageSize: 10, // 每页条数
      currentNum: 0, // 当前页码
      totalNum: 0, // 数据总条数
      downLoadPdf: globalData.downLoadPdf, // pdf链接前缀
      searchLevel: "common", // common普通搜索，senior高级搜索
      addListModal: false, // 新增弹框
      deleteStatus: false, //删除弹框
      deletedTitle: "", // 已选中的章节标题
      selectedList: [], // 已选中的章节
      chapterName: "", // 章节名称
      searchIpt: {
        keyword: "",
        seniorKeyword: "",
        region: "",
        schoolName: "",
        classId: "",
        className: "",
        parentId: ""
      },
      tableHeader: [
        {
          type: "selection",
          width: 60,
          align: "center"
        },
        {
          title: "章节名称",
          key: "name"
        },
        {
          title: "题数",
          key: "questionCount"
        },
        {
          title: "创建时间",
          key: "createTime"
        },
        {
          title: "状态",
          key: "status",
          slot: "status"
        },
        {
          title: "操作",
          slot: "action",
          align: "center",
          width: 400
        }
      ],
      tableData: [],
      regionList: [
        {
          value: "beijing",
          label: "北京",
          children: [
            {
              value: "gugong",
              label: "故宫"
            },
            {
              value: "tiantan",
              label: "天坛"
            },
            {
              value: "wangfujing",
              label: "王府井"
            }
          ]
        },
        {
          value: "jiangsu",
          label: "江苏",
          children: [
            {
              value: "nanjing",
              label: "南京",
              children: [
                {
                  value: "fuzimiao",
                  label: "夫子庙"
                }
              ]
            },
            {
              value: "suzhou",
              label: "苏州",
              children: [
                {
                  value: "zhuozhengyuan",
                  label: "拙政园"
                },
                {
                  value: "shizilin",
                  label: "狮子林"
                }
              ]
            }
          ]
        }
      ],
      gradesList: [
        {
          label: "一",
          value: 1
        },
        {
          label: "二",
          value: 2
        },
        {
          label: "三",
          value: 3
        },
        {
          label: "四",
          value: 4
        },
        {
          label: "五",
          value: 5
        },
        {
          label: "六",
          value: 6
        },
        {
          label: "七",
          value: 7
        },
        {
          label: "八",
          value: 8
        },
        {
          label: "九",
          value: 9
        }
      ], //年级列表
      subjectList: [
        {
          label: "语文",
          value: 1
        },
        {
          label: "数学",
          value: 2
        },
        {
          label: "英语",
          value: 3
        }
      ],
      addEditorData: {
        cardId: 0,
        sheetId: 0,
        name: "",
        seqno: "",
        mode: "每道大题重新排列"
      }
    };
  },
  methods: {
    //      确定新增、编辑
    confirmAddEditor() {
      const self = this;
      let dataInfo = {
        cardId: self.addEditorData.cardId,
        sheetId: 0,
        name: self.addEditorData.name,
        seqno: self.addEditorData.seqno,
        mode: self.addEditorData.mode === "每道大题重新排列" ? 0 : 1
      };
      _getConfirmAddChapter(dataInfo).then(res => {
        if (res.code === 0) {
          self.addListModal = false;
          self.$router.push(`/answer/MakeTestCard?id=${res.data}&status=false`);
        }
      });
    },
    //新建章节排序方式
    changeSortOrder(msg) {
      console.log("msg--", msg);
      this.addEditorData.mode = msg;
    },
    //  跳转到题库列表
    toQuestionBank(row) {
      this.$router.push(
        `/answer/questionbank?id=${row.sheetId}&mode=${row.mode}`
      );
    },
    //      教辅章节铺码
    startChapterLayingCode(sheetId) {
      const self = this;
      _startChapterLayingCode(sheetId)
        .then(res => {
          if (res.code === 0) {
            alertTips("success", "铺码中……");
          }
        })
        .catch(err => {
          alertTips("error", "请求失败，请刷新");
        });
    },

    //      删除章节弹框显示
    deleteChapter(row) {
      this.deleteStatus = true;
      this.deletedTitle = row.name;
      this.addEditorData.sheetId = row.sheetId;
    },
    //      确定删除某个章节
    confirmDeleteBtn() {
      const self = this;
      _deleteChapter(self.addEditorData.sheetId).then(res => {
        if (res.code === 0) {
          self.deleteStatus = false;
          alertTips("success", "删除成功");
          self.getAnswerChapterList();
        }
      });
    },
    //     新增，编辑弹框状态监测
    addEditorChange(boolean) {
      if (!boolean) {
        this.addEditorData.name = "";
      }
    },
    //     勾选变化事件
    selectedChange(msg) {
      this.selectedList = msg;
    },
    //      编辑章节答题卡
    toEditor(row) {
      this.$router.push(`/answer/MakeTestCard?id=${row.sheetId}&status=false`);
    },
    //      章节答题卡录入答案
    toAddAnswer(row) {
      this.$router.push(`/answer/MakeTestCard?id=${row.sheetId}&status=true`);
    },
    //      查询答题本章节列表(我发布的)
    getAnswerChapterList(msg) {
      const self = this;
      let params = {
        page: typeof msg === "object" && msg.pageNum ? msg.pageNum - 1 : 0,
        size: self.pageSize,
        sort: "seqno"
      };
      _getAnswerChapterList({ params: params, id: self.addEditorData.cardId })
        .then(res => {
          if (res.code === 0) {
            if (res.data.content.length > 0) {
              res.data.content.forEach(item => {
                item.createTime = YearMonthDate(item.createTime);
              });
              let status = res.data.content.every(item => {
                return item.status >= 4 || item.status == 2 || item.status == 0;
              });
              status && clearInterval(timer);
            } else {
              clearInterval(timer);
            }
            self.tableData = res.data.content;
            self.totalNum = res.data.total;
          } else {
            clearInterval(timer);
          }
        })
        .catch(err => {
          clearInterval(timer);
        });
    },
    toSchoolDetail(schoolId) {
      const self = this;
      self.$router.push(`/schools?id=${schoolId}`);
    },
    //      跳转到班级列表
    toRelationClass(classId) {
      this.$router.push(`/klasses?classId=${classId}`);
    },
    //      跳转到用户列表
    toRelationParents() {},
    checkDetail(rowData) {
      const self = this;
      console.log("id", rowData.studentId);
      self.$router.push(`/students/detail?id=${rowData.studentId}`);
    },
    topSearchFn() {
      this.searchLevel = "senior";
      //        this.getStudentList();
      this.searchIpt = {
        seniorKeyword: "",
        region: "",
        schoolName: "",
        classId: "",
        className: "",
        parentId: ""
      };
      this.topSearchStatus = false;
    }, //上传图片压缩包
    paperSsheetsImages(sheetId) {
      this.$root.$emit("openUploader", data => {
        _paperSsheetsImages({
          sheetId,
          zip: data.uri
        }).then(res => {
          if (res.code === 0) {
            this.$Message.success("上传完成");
          }
        });
      });
    },
    cancelSearchModel() {}
  },
  created() {
    const self = this;
    if (self.$route.query.id) {
      self.addEditorData.cardId = self.$route.query.id;
    }
    timer = setInterval(self.getAnswerChapterList, 5000);
    self.getAnswerChapterList();
  },
  beforeRouteLeave(to, from, next) {
    clearInterval(timer);
    next();
  },
  mounted() {}
};
</script>
<style scoped>
.delete_tips_info {
  text-align: center;
  font-size: 18px;
  color: #333;
}
.order_mode {
  font-size: 14px;
}
.order_mode > .search_item_label {
  margin-right: 30px;
}
.order_mode .radio_item {
  margin-right: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/ChapterList.vue